
// import React, { useState } from 'react';
// import Logo from '../../assets/Logo.svg';
// import bgImage from "../../assets/back.png";
// import { Link } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
// import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {registerCompany} from '../../ApiController/ApiService'

// const Signup = () => {
//     const [showPassword, setShowPassword] = useState(false);
//     const navigate = useNavigate();

//     return (
//         <div
//             className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
//             style={{ backgroundImage: `url(${bgImage})` }}
//         >
//             <div className="flex flex-col items-center relative">
//                 {/* Logo outside the container */}
//                 <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

//                 {/* Login container */}
//                 <div
//                     className="relative bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[490px] ps-8 pe-8 pb-8 pt-4 text-center"
//                 >
//                  <button
//                   onClick={() => navigate(-1)}
//                   className="absolute top-4 left-4 text-[#2D0076] text-xl hover:text-[#6F1AFF] transition"
//                 >
//                   <FontAwesomeIcon icon={faArrowLeft} />
//                 </button>
//                     <h2 className="text-2xl font-bold font-inter text-[#2D0076] font-[32px] text-gray-900">Welcome</h2>
//                     <p className="text-sm font-nunito text-[#202224] font-600 mb-6">Create Your Company Dispatcher Account</p>

//                     <form onSubmit={(e) => {
//     e.preventDefault();
//     navigate('/createpassword'); }} >
//                         <div className="text-left mb-4">
//                             <label className="block font-[18px] text-[#20224] mb-1">Company Name</label>
//                             <input
//                                 type="text"
//                                 placeholder="Enter your company name"
//                                 className="w-full px-4 py-2 border bg-[#F1F4F9] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//                             />
//                         </div>

//                         <div className="text-left mb-4">
//                             <label className="block font-[18px] text-[#20224] mb-1">Company Email</label>
//                             <input
//                                 type="email"
//                                 placeholder="Enter a valid business email"
//                                 className="w-full px-4 py-2 bg-[#F1F4F9] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//                             />
//                         </div>

//                         <div className="text-left mb-4">
//                             <label className="block font-[18px] text-[#20224] mb-1">Contact Number</label>
//                             <input
//                                 type="tel"
//                                 placeholder="Enter your phone number"
//                                 className="w-full px-4 py-2 bg-[#F1F4F9] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//                             />
//                         </div>

//                         <button
//                             type="submit"
//                             className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition"
//                         >
//                             Next
//                         </button>
//                     </form>

//                     <p className="text-[#00217A] font-[20px] mt-6">
//                         Have an account? <Link to="/" className="text-[#00217A] font-[20px] font-bold hover:underline">Login</Link>
//                     </p>

//                     <div className="mt-4 w-full">
//                         <div className="-mx-8 flex items-center justify-center w-auto mb-4">
//                             <div className="border-t border-gray-300 w-full"></div>
//                             <span className="mx-4 text-sm text-gray-500 whitespace-nowrap">Or Login with</span>
//                             <div className="border-t border-gray-300 w-full"></div>
//                         </div>
//                         <div className="flex justify-center gap-4">
//                             <button className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow">
//                                 <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/145/145802.png" alt="Facebook" />
//                             </button>
//                             <button className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow">
//                                 <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/281/281764.png" alt="Google" />
//                             </button>
//                             <button className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow">
//                                 <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/0/747.png" alt="Apple" />
//                             </button>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </div>

//     );
// };

// export default Signup;
// import React, { useState } from 'react';
// import Logo from '../../assets/Logo.svg';
// import bgImage from "../../assets/back.png";
// import { Link, useNavigate } from 'react-router-dom';
// import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { registerCompany } from '../../ApiController/ApiService';

// const Signup = () => {
//   const [companyName, setCompanyName] = useState('');
//   const [email, setEmail] = useState('');
//   const [phone, setPhone] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);

//     const data = {
//       fullName: companyName,
//       firstName: companyName,
//       lastName: "",
//       mobileNumber: phone,
//       email: email,
//       password: "admin@1234", // Consider removing hardcoded password
//     };

//     try {
//       const result = await registerCompany(data);
//       console.log("Registration Success:", result);
//       navigate('/createpassword');
//     } catch (error) {
//       setError(error.message);
//       console.error("Registration Error:", error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
//       style={{ backgroundImage: `url(${bgImage})` }}
//     >
//       <div className="flex flex-col items-center relative">
//         <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

//         <div className="relative bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[490px] ps-8 pe-8 pb-8 pt-4 text-center">
//           <button
//             onClick={() => navigate(-1)}
//             className="absolute top-4 left-4 text-[#2D0076] text-xl hover:text-[#6F1AFF] transition"
//           >
//             <FontAwesomeIcon icon={faArrowLeft} />
//           </button>

//           <h2 className="text-2xl font-bold text-[#2D0076] font-inter">Welcome</h2>
//           <p className="text-sm font-nunito text-[#202224] mb-6">
//             Create Your Company Dispatcher Account
//           </p>

//           {error && (
//             <p className="text-red-500 text-sm mb-4">{error}</p>
//           )}

//           <form onSubmit={handleSubmit}>
//             <div className="text-left mb-4">
//               <label className="block font-[18px] text-[#202224] mb-1">Company Name</label>
//               <input
//                 type="text"
//                 value={companyName}
//                 onChange={(e) => setCompanyName(e.target.value)}
//                 placeholder="Enter your company name"
//                 required
//                 className="w-full px-4 py-2 border bg-[#F1F4F9] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//               />
//             </div>

//             <div className="text-left mb-4">
//               <label className="block font-[18px] text-[#202224] mb-1">Company Email</label>
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 placeholder="Enter a valid business email"
//                 required
//                 className="w-full px-4 py-2 bg-[#F1F4F9] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//               />
//             </div>

//             <div className="text-left mb-4">
//               <label className="block font-[18px] text-[#202224] mb-1">Contact Number</label>
//               <input
//                 type="tel"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value)}
//                 placeholder="Enter your phone number"
//                 required
//                 className="w-full px-4 py-2 bg-[#F1F4F9] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition disabled:opacity-50"
//             >
//               {loading ? "Submitting..." : "Next"}
//             </button>
//           </form>

//           <p className="text-[#00217A] font-[20px] mt-6">
//             Have an account? <Link to="/" className="text-[#00217A] font-[20px] font-bold hover:underline">Login</Link>
//           </p>

//           <div className="mt-4 w-full">
//             <div className="-mx-8 flex items-center justify-center w-auto mb-4">
//               <div className="border-t border-gray-300 w-full"></div>
//               <span className="mx-4 text-sm text-gray-500 whitespace-nowrap">Or Login with</span>
//               <div className="border-t border-gray-300 w-full"></div>
//             </div>

//             <div className="flex justify-center gap-4">
//               <button className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow">
//                 <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/145/145802.png" alt="Facebook" />
//               </button>
//               <button className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow">
//                 <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/281/281764.png" alt="Google" />
//               </button>
//               <button className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow">
//                 <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/0/747.png" alt="Apple" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Signup;
import React, { useState } from 'react';
import Logo from '../../assets/Logo.svg';
import bgImage from "../../assets/back.png";
import { Link, useNavigate } from 'react-router-dom';
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { registerCompany } from '../../ApiController/ApiService';

const Signup = () => {
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Instead of calling API here, pass data to SignupPassword
    navigate('/createpassword', {
      state: {
        fullName: companyName,
        firstName: companyName,
        lastName: "",
        mobileNumber: phone,
        email: email,
      },
    });
    setLoading(false);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="flex flex-col items-center relative">
        <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

        <div className="relative bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[490px] ps-8 pe-8 pb-8 pt-4 text-center">
          <button
            onClick={() => navigate(-1)}
            className="absolute top-4 left-4 text-[#2D0076] text-xl hover:text-[#6F1AFF] transition"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>

          <h2 className="text-2xl font-bold text-[#2D0076] font-inter">Welcome</h2>
          <p className="text-sm font-nunito text-[#202224] mb-6">
            Create Your Company Dispatcher Account
          </p>

          {error && (
            <p className="text-red-500 text-sm mb-4">{error}</p>
          )}

          <form onSubmit={handleSubmit}>
            <div className="text-left mb-4">
              <label className="block font-[18px] text-[#202224] mb-1">Company Name</label>
              <input
                type="text"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                placeholder="Enter your company name"
                required
                className="w-full px-4 py-2 border bg-[#F1F4F9] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <div className="text-left mb-4">
              <label className="block font-[18px] text-[#202224] mb-1">Company Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter a valid business email"
                required
                className="w-full px-4 py-2 bg-[#F1F4F9] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <div className="text-left mb-4">
              <label className="block font-[18px] text-[#202224] mb-1">Contact Number</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Enter your phone number"
                required
                className="w-full px-4 py-2 bg-[#F1F4F9] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition disabled:opacity-50"
            >
              {loading ? "Submitting..." : "Next"}
            </button>
          </form>

          <p className="text-[#00217A] font-[20px] mt-6">
            Have an account? <Link to="/login" className="text-[#00217A] font-[20px] font-bold hover:underline">Login</Link>
          </p>

          {/* <div className="mt-4 w-full">
            <div className="-mx-8 flex items-center justify-center w-auto mb-4">
              <div className="border-t border-gray-300 w-full"></div>
              <span className="mx-4 text-sm text-gray-500 whitespace-nowrap">Or Login with</span>
              <div className="border-t border-gray-300 w-full"></div>
            </div>

            <div className="flex justify-center gap-4">
              <button className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow">
                <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/145/145802.png" alt="Facebook" />
              </button>
              <button className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow">
                <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/281/281764.png" alt="Google" />
              </button>
              <button className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow">
                <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/0/747.png" alt="Apple" />
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Signup;